import React from "react";
import { HStack, Heading, Button, Icon, Box } from "@chakra-ui/react";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";

import { getHumanReadableStepName } from "@constants";

interface IEventHeader {
  stepName: string;
  isBodyCollapsed: boolean;
  toggleBodyCollapse: () => void;
}

function EventHeader({
  stepName,
  isBodyCollapsed,
  toggleBodyCollapse,
}: IEventHeader) {
  return (
    <HStack alignItems="baseline">
      <Heading as="h4" size="md">
        {getHumanReadableStepName(stepName)}
      </Heading>
      <Box flex="1" />
      <Button onClick={toggleBodyCollapse} variant="ghost">
        <Icon as={isBodyCollapsed ? FaCaretUp : FaCaretDown} />
      </Button>
    </HStack>
  );
}

export { EventHeader };
